import filtersDisplayConfig from "./filtersDisplay.config";
import apiPathsConfig from './apiPaths.config';
import availableActionsConfig from "./availableActions.config";
import availableListViewsConfig from "./availableListViews.config";

const itemsListerConfig = {
  apiPathsConfig,
  filtersDisplayConfig,
  availableActionsConfig,
  availableListViewsConfig,
}

export default itemsListerConfig;